export const ELEVAR_BRAND = 'Birch Living';
export const ELEVAR_CDN_ORIGIN = 'https://shopify-gtm-suite.getelevar.com';
export const ELEVAR_CONFIG_ID = '1ca0b7010e6ef1402a9786e4ca9c9911a4f589d5';
export const ELEVAR_DEFAULT_CURRENCY_CODE = 'USD';
export const ELEVAR_VIEW_CART_MAX_ITEMS = 4;
export const ELEVAR_IMPRESSIONS_MAX_CHARS = 4000;
export const ELEVAR_REFERRING_COLLECTION_KEY = 'referringCollection';
export const ELEVAR_INVALIDATE_CONTEXT_TIMEOUT_MS = 3000;
